import { render, staticRenderFns } from "./ProcessoCompraList.vue?vue&type=template&id=6fa9cdca"
import script from "./ProcessoCompraList.vue?vue&type=script&lang=js"
export * from "./ProcessoCompraList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports